var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto pt-3",attrs:{"max-width":"650","to":"/","flat":""}},[_c('v-card-title',[_vm._v(" В стадии публикации, может быть выслана по запросу ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }